import { useEffect, useState } from 'react';

function useTrackFilteredChannels({
  channels,
  channelsSelected,
  isWeekly,
  track
}) {
  const [previousChannelsCount, setPreviousState] = useState(-1);
  const [hasChannels, setHasChannels] = useState(false);
  useEffect(() => {
    const isChannelsListsInitialized =
      !hasChannels && channelsSelected.length > 0;
    const isPreviousChannelCountValid = previousChannelsCount !== -1;

    if (isChannelsListsInitialized) {
      setHasChannels(true);
      setPreviousState(channelsSelected.length);
    }
    if (hasChannels) {
      setPreviousState(channelsSelected.length);
    }
    if (isPreviousChannelCountValid) {
      track({
        channelCount: channelsSelected.length,
        isWeekly,
        previousChannelCount: previousChannelsCount,
        selectedChannelIDs: channelsSelected,
        availableChannelIDs: channels.map(c => c.id),
      });
    }
  }, [channelsSelected]);
}

export default useTrackFilteredChannels;
